import axios from "axios";
import constant from "../Common/Constant";
export default axios.create({
  baseURL: constant.baseUrl,
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Credentials": true,
  },
});
